import { Box, Stack, Typography} from "@mui/material";
import { themeColors } from "../styles/theme";
import { PrimaryButton } from "./Home";
import { Dispatch, SetStateAction, } from "react";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { useNavigate } from "react-router-dom";

interface FiltersAndTabSelectorProps {
    tab: 'list' | 'map';
    setTab: (value: 'list' | 'map') => void;
    sortBy: 'distance' | 'rating';
    setSortBy: Dispatch<SetStateAction<'distance' | 'rating'>>;
    sortDirection: 'asc' | 'desc';
    setSortDirection: Dispatch<SetStateAction<'asc' | 'desc'>>;
    customRadius: number;
    setCustomRadius: Dispatch<SetStateAction<number>>;
    handleApplyFilters: () => void;
    hideNoGardens: boolean;
    setHideNoGardens: Dispatch<SetStateAction<boolean>>;
    loading: boolean;
}

export const FiltersAndTabSelector = ({
    tab,
    setTab,
    sortBy,
    setSortBy,
    sortDirection,
    setSortDirection,
    customRadius,
    setCustomRadius,
    handleApplyFilters,
    hideNoGardens,
    setHideNoGardens,
    loading
}: FiltersAndTabSelectorProps
) => {
    const navigate = useNavigate();

    return (
        !loading ? <Box
            sx={{
                display: 'flex',
                alignItems: 'flex-start',
                justifyContent: 'flex-start',
                backgroundColor: 'transparent',
                marginTop: '26px',
                marginLeft: '5%',
                width: '90%',
            }}
        >
            <Stack direction={'column'} width={'100%'}>
                <Stack direction={'row'} sx={{ justifyContent: 'flex-start', width: '100%', mb: 2 }}>
                    <PrimaryButton
                        sx={{
                            width: '80px',
                            minWidth: '80px',
                            mr: 0.5,
                            border: `1px solid ${themeColors.darkBackground}`,
                        }}
                        onClick={() => navigate('/search-area')}
                        startIcon={<LocationOnIcon />}
                    >
                        {'Area'}
                    </PrimaryButton>
                    <PrimaryButton
                        sx={{
                            width: '140px',
                            minWidth: '130px',
                            mr: 0.5,
                            border: `1px solid ${themeColors.darkBackground}`,
                        }}
                        onClick={() => setHideNoGardens(!hideNoGardens)}
                        startIcon={hideNoGardens ? <HighlightOffIcon /> : <CheckCircleOutlineIcon />}
                    >
                        {'No gardens'}
                    </PrimaryButton>
                    <PrimaryButton
                        sx={{
                            width: '70px',
                            minWidth: '70px',
                            border: `1px solid ${themeColors.darkBackground}`,
                        }}
                        onClick={() => {
                            setTab(tab === 'list' ? 'map' : 'list');
                        }}
                    >
                        {tab === 'list' ? 'Map' : 'List'}
                    </PrimaryButton>
                </Stack>
                                {tab === 'list' && (
                    <Stack direction={'row'} sx={{ justifyContent: 'flex-end', width: '100%' }} >
                        <Typography variant="subtitle1"
                            sx={{
                                fontSize: '1.1rem',
                                fontWeight: 500,
                                color: themeColors.darkBackground,
                                marginRight: '8px',
                                fontFamily: "ApfelGrotezkRegular",
                            }}
                        >
                            Sort by{' '}
                            
                             <Box
                                 component="span"
                                 onClick={() => setSortBy('rating')}
                                 sx={{
                                     cursor: 'pointer',
                                     textDecoration: sortBy === 'rating' ? 'underline' : 'none',
                                     '&:hover': {
                                         opacity: 0.8,
                                     },
                                 }}
                             >
                                 [Sun]
                             </Box>
                             {' / '}
                             <Box
                                 component="span"
                                 onClick={() => setSortBy('distance')}
                                 sx={{
                                     cursor: 'pointer',
                                     textDecoration: sortBy === 'distance' ? 'underline' : 'none',
                                     '&:hover': {
                                         opacity: 0.8,
                                     },
                                 }}
                             >
                                 [Distance]
                             </Box>
                        </Typography>
                    </Stack>
                )}
            </Stack>
        </Box> : null);
}